import { useEffect, useRef } from 'react';
import { useReactFlow } from '@xyflow/react';
import { animationDuration } from '../utils/layout';

const FitViewHelper = ({ nodes, edges, isReady }) => {
  const { fitView } = useReactFlow();
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Only fit view on initial load, not on subsequent updates
    if (hasInitialized.current) return;
    // Wait until initial layout is ready (after collapse)
    if (!isReady) return;

    const timer = setTimeout(() => {
      fitView({ padding: 0.1, duration: animationDuration });
      hasInitialized.current = true;
    }, 0);

    return () => clearTimeout(timer);
  }, [nodes, edges, fitView, isReady]);

  return null;
};

export default FitViewHelper;

